import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class StepperEventsService {
    protected _nextTopic = new Subject<string>();
    protected _prevTopic = new Subject<string>();
    protected _gotoTopic = new Subject<string>();

    get nextTopic(): Subject<string> {
        return this._nextTopic;
    }

    get prevTopic(): Subject<string> {
        return this._prevTopic;
    }

    get gotoTopic(): Subject<string> {
        return this._gotoTopic;
    }
}
